import flatpickr from 'flatpickr'
// eslint-disable-next-line no-restricted-imports
import l10n from 'flatpickr/dist/l10n'

const validateLocale = (localeString: string): string => {
  const normalizedLocale = localeString.toLowerCase()
  const [mainLocale] = normalizedLocale.split('-')
  const locale = Object.keys(l10n).find(
    localeKey => localeKey === normalizedLocale || localeKey === mainLocale,
  )
  if (locale) {
    // flatpickr contains 'en' in l10n.keys but no en.js module
    return locale === 'en' ? 'default' : locale
  }
  return 'default'
}

export const localizeFlatpickr = async (locale: string) => {
  const flatpickrLocale = validateLocale(locale)
  await import(
    /* webpackInclude: /(default|de|es|fr|ko|pt|tr|zh)(-[A-Za-z]{2})?\.js$/ */
    /* webpackChunkName: "flatpickr-locale-[request]" */
    /* webpackMode: "lazy" */
    /* webpackPrefetch: false */
    /* webpackPreload: false */
    `flatpickr/dist/l10n/${flatpickrLocale}.js`
  )
  flatpickr.localize(flatpickr.l10ns[flatpickrLocale])
}
